// src/utils/api.js
import { expireSession, getAuthToken } from "./authSession";

const IS_LOCAL = process.env.NODE_ENV === "development";
const BASE_URL = IS_LOCAL
  ? process.env.REACT_APP_API_LOCAL_URL || "http://localhost:3000/api"
  : "/api";

export const RATE_LIMIT_MESSAGE = "Whoa - slow down there! We've detected an unusually high amount of searches from you. Please wait a while and try again later :)";
export const RATE_LIMIT_EVENT = "stylisher:rate-limited";

export async function fetchWithAuth(endpoint, options = {}) {
  const method = options.method || "GET";
  const token = getAuthToken();

  const url = `${BASE_URL}${endpoint}`;

  // Minimal change: ensure token is included safely
  const headers = {
    ...(options.headers || {}),
    "Content-Type": "application/json",
    ...(token ? { "x-auth-token": token } : {}),
  };

  if (IS_LOCAL && process.env.REACT_APP_API_TOKEN) {
    headers["Authorization"] = `Bearer ${process.env.REACT_APP_API_TOKEN}`;
  }

  const res = await fetch(url, {
    method,
    headers,
    body: method !== "GET" ? JSON.stringify(options.body) : undefined,
  });

  if (res.status === 429) {
    window.dispatchEvent(new Event(RATE_LIMIT_EVENT));
    const error = new Error(RATE_LIMIT_MESSAGE);
    error.status = 429;
    throw error;
  }

  const contentType = res.headers.get("content-type") || "";
  const text = await res.text();

  if (!res.ok) {
    let responseError;
    try {
      responseError = JSON.parse(text).error;
    } catch {
      // Non-JSON errors still use the original response below.
    }
    if (token && (res.status === 401 ||
        (res.status === 403 && responseError === "Forbidden: Invalid token"))) {
      expireSession(token);
    }
    const error = new Error(text || `API error: ${res.status}`);
    error.status = res.status;
    throw error;
  }

  try {
    return contentType.includes("application/json") ? JSON.parse(text) : { raw: text };
  } catch (err) {
    throw new Error("Proxy returned invalid JSON");
  }
}
